import { useState, useEffect, useCallback } from 'react';
import { fetchFilterOptions } from '@/services/api';

/**
 * Shared hook for managing post-analysis filter options and
 * fetching refined options based on locally edited filters.
 *
 * @param {object} baseFilterOptions - Initial options from the main data hook.
 */
export function usePostAnalysisFilters(baseFilterOptions = {}) {
  const [localFilterOptions, setLocalFilterOptions] = useState(baseFilterOptions || {});

  // Keep local options in sync with upstream options when they change
  useEffect(() => {
    setLocalFilterOptions(baseFilterOptions || {});
  }, [baseFilterOptions]);

  // Fetch refined filter options whenever the user changes local filters
  const handleLocalFiltersChange = useCallback(async (localFilters) => {
    try {
      const campaignArray = Array.isArray(localFilters.campaign)
        ? localFilters.campaign
        : (localFilters.campaign ? [localFilters.campaign] : []);
      const pocIdArray = Array.isArray(localFilters.poc_id)
        ? localFilters.poc_id
        : (localFilters.poc_id ? [localFilters.poc_id] : []);
      const pocNameArray = Array.isArray(localFilters.poc_name)
        ? localFilters.poc_name
        : (localFilters.poc_name ? [localFilters.poc_name] : []);

      const options = await fetchFilterOptions(
        localFilters.region || undefined,
        localFilters.brand || undefined,
        campaignArray.length > 0 ? campaignArray : undefined,
        localFilters.start_date || undefined,
        localFilters.end_date || undefined,
        pocIdArray.length > 0 ? pocIdArray : undefined,
        pocNameArray.length > 0 ? pocNameArray : undefined,
        localFilters.key_account || undefined
      );

      setLocalFilterOptions(options || {});
    } catch (err) {
      console.error('Error fetching local filter options:', err);
    }
  }, []);

  return {
    localFilterOptions,
    setLocalFilterOptions,
    handleLocalFiltersChange,
  };
}

